module.exports = __webpack_public_path__ + "static/media/udemy.c473499f.svg";